import { render, staticRenderFns } from "./CreateBooking.vue?vue&type=template&id=36627d9a&scoped=true"
import script from "./CreateBooking.vue?vue&type=script&lang=js"
export * from "./CreateBooking.vue?vue&type=script&lang=js"
import style0 from "./CreateBooking.vue?vue&type=style&index=0&id=36627d9a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36627d9a",
  null
  
)

export default component.exports